import { defaultServer } from '~/api/def/servers/defaultServer';
import { getExecEndpoint } from '../../service/getExecEndpoint';
import { BqResponse } from './types';

export const pcEvaluationEventEndpoint = {
  server: defaultServer,
  path: 'portfoliocompany',
  description: 'Portfolio company valuation event endpoint',
};

// Add a new endpoint for the pcvaluationevent CRUD operations
export const pcValuationEventCrudEndpoint = {
  server: defaultServer,
  path: 'crud/pcvaluationevent',
  description: 'Portfolio company valuation event CRUD operations',
};

const endpointPcValuationEventPostExec =
  getExecEndpoint<PcEvaluationEventEndpointDef>(pcEvaluationEventEndpoint);
export const pcEvaluationEventPOST = async (
  payload: PcEvaluationEventPayload,
) => {
  return endpointPcValuationEventPostExec<'POST'>({
    method: 'POST',
    payload: payload,
    urlExtra: `/${payload.portfolioCompanyId}/valuation-event`,
  });
};

// Add the DELETE endpoint for pcvaluationevent
const endpointPcValuationEventCrudExec =
  getExecEndpoint<PcValuationEventCrudEndpointDef>(
    pcValuationEventCrudEndpoint,
  );

export const endpointPcValuationEventDELETE = async (
  valuationEventId: string,
) => {
  const response = await endpointPcValuationEventCrudExec<'DELETE'>({
    method: 'DELETE',
    urlExtra: `/${valuationEventId}`,
  });

  if (!response) {
    throw new Error('Could not delete valuation event');
  }

  if (response.success === 0) {
    throw new Error('Could not delete valuation event');
  }

  return response;
};

export interface PcEvaluationEventEndpointDef {
  endpoint: typeof pcEvaluationEventEndpoint;
  methods: {
    POST: {
      response: PcEvaluationEventResponse;
      payload: PcEvaluationEventPayload;
    };
  };
}

// Add interface for the CRUD endpoint
export interface PcValuationEventCrudEndpointDef {
  endpoint: typeof pcValuationEventCrudEndpoint;
  methods: {
    DELETE: {
      response: BqResponse<{ success: number }>;
    };
  };
}

export type PcEvaluationEventResponse = BqResponse<{
  data: object;
}>;

type PcEvaluationEventPayload = {
  extractedFieldIds: string[];
  portfolioCompanyId: string;
  documentId: string;
};
